// src/utils/cities.js
export const provincesWithCities = {
    'Eastern Cape': [
        'Gqeberha', 'East London', 'Bethelsdorp', 'Uitenhage', 'Mthatha',
        'Grahamstown', 'Queenstown', 'Despatch', 'Humansdorp', 'Jeffrey\'s Bay',
        'Port Alfred', 'Kirkwood', 'Summerstrand', 'Mount Fletcher', 'Gonubie',
        'Bhisho', 'Alexandria', 'Cradock', 'Lorraine', 'Breidbach',
        'Cookhouse', 'Mount Ayliff', 'Mount Frere', 'Flagstaff', 'Bluewater Bay',
        'Pearston', 'Lusikisiki', 'Aliwal North', 'Alicedale', 'Lesseyton',
        'Mqanduli'
    ],
    'Free State': [
        'Bloemfontein', 'Kroonstad', 'Sasolburg', 'Thaba Nchu', 'Welkom',
        'Odendaalsrus', 'Phuthaditjhaba', 'Allanridge', 'Riebeeckstad', 'Tweeling',
        'Ficksburg', 'Cornelia'
    ],
    'Gauteng': [
        'Johannesburg', 'Soweto', 'Katlehong', 'Pretoria', 'Randburg',
        'Roodepoort', 'Boksburg', 'Germiston', 'Centurion', 'Sandton',
        'Kempton Park', 'Benoni', 'Krugersdorp', 'Springs', 'Alberton',
        'Vereeniging', 'Randfontein', 'Kwamhlanga', 'Edenvale', 'Nigel',
        'Bronkhorstspruit', 'Garsfontein', 'Turffontein', 'Primrose', 'Bedfordview',
        'Pretoria-Noord', 'Westonaria', 'Doornkop', 'Cullinan', 'Rayton',
        'Elsburg', 'Oberholzer', 'Waterkloof', 'Fontainebleau', 'Three Rivers'
    ],
    'KwaZulu-Natal': [
        'Pietermaritzburg', 'Durban', 'Newcastle', 'Nqutu', 'Pinetown',
        'Empangeni', 'KwaDukuza', 'Ladysmith', 'Richards Bay', 'Queensburgh',
        'Kokstad', 'Dundee', 'Vryheid', 'Westville', 'Ulundi',
        'Mondlo', 'Margate', 'Mpophomeni', 'uMhlanga Rocks', 'Estcourt',
        'Howick', 'Ballitoville', 'Glencoe', 'Kingsborough', 'eMuziwezinto',
        'eManzimtoti', 'Hillcrest', 'Groutville', 'eXobho', 'Scottburgh',
        'Ekuvukeni', 'Greytown', 'Gillitts', 'Mount Edgecombe', 'eManguzi',
        'Lidgetton', 'Uvongo Beach', 'Park Rynie', 'Warner Beach', 'Richmond',
        'Shakaskraal', 'La Mercy', 'Botha\'s Hill', 'Doonside'
    ],
    'Limpopo': [
        'Polokwane', 'Thohoyandou', 'Musina', 'Acornhoek', 'Thabazimbi',
        'Louis Trichardt', 'Nkowakowa', 'Okkerneutboom', 'Phalaborwa', 'Buffelshoek',
        'Lenyenye', 'Ga-Kgapane', 'Welverdiend', 'Jane Furse', 'Olifantshoek',
        'Sibasa'
    ],
    'Mpumalanga': [
        'Middelburg', 'Ermelo', 'Kwaggafontein', 'Standerton', 'Secunda',
        'Lydenburg', 'Siyabuswa', 'Breyten', 'Elandsdoorn', 'Casteel',
        'Jeppe\'s Reef', 'Barberton', 'Langeloop', 'Evander', 'Boekenhouthoek',
        'Sabie', 'Buffelspruit', 'Bosfontein', 'Wolwekraal', 'Waterval Boven',
        'Magudu', 'Graskop', 'Eloff', 'Malelane', 'Sheepmoor',
        'Nelspruit'
    ],
    'North West': [
        'Rustenburg', 'Klerksdorp', 'Potchefstroom', 'Winterveld', 'Brits',
        'Phokeng', 'Lichtenburg', 'Pampierstad', 'Hammanskraal', 'Vryburg',
        'Itsoseng', 'Stilfontein', 'Mahikeng', 'Orkney', 'Mogogelo',
        'Vaal Reefs', 'Mogwase', 'Fochville', 'Magogong', 'Mayeakgoro',
        'Sonop', 'Madikwe', 'Rooigrond'
    ],
    'Northern Cape': [
        'Kimberley', 'Upington', 'Prieska', 'Daniëlskuil', 'Kuruman',
        'Kathu', 'Noupoort', 'Dibeng', 'Carnarvon', 'Griekwastad',
        'Okiep', 'Port Nolloth', 'Nababeep', 'Britstown', 'Kenhardt',
        'Hanover', 'Lime Acres', 'Komaggas'
    ],
    'Western Cape': [
        'Cape Town', 'George', 'Parow', 'Paarl', 'Worcester',
        'Oudtshoorn', 'Stellenbosch', 'Mossel Bay', 'Wellington', 'Kuilsrivier',
        'Grabouw', 'Vredenburg', 'Malmesbury', 'Ceres', 'Saldanha',
        'Vredendal', 'Swellendam', 'Riversdale', 'Montagu', 'Dysselsdorp',
        'Gansbaai', 'Velddrif', 'Heidelberg', 'Hawston', 'Touwsrivier',
        'Saron', 'Citrusdal', 'Vanrhynsdorp', 'Laingsburg', 'Genadendal',
        'Hermanus', 'Botrivier', 'Riebeek-Wes', 'Hartenbos', 'Sandbaai',
        'Stilbaai', 'Rawsonville'
    ]
};

// Get all cities as a flat array for autocomplete or dropdown
export const getAllCities = () => {
    const allCities = [];
    Object.values(provincesWithCities).forEach(cities => {
        allCities.push(...cities);
    });
    return allCities.sort();
};

// Get cities by province
export const getCitiesByProvince = (province) => {
    return provincesWithCities[province] || [];
};

// Get province by city
export const getProvinceByCity = (city) => {
    for (const [province, cities] of Object.entries(provincesWithCities)) {
        if (cities.includes(city)) {
            return province;
        }
    }
    return null;
};